import './css/style.css';
import MultipleGridImages from './components/Images';
import Img from './components/ReactImageVideoLightbox/img';
export { Img };
export default MultipleGridImages;